import styled, { css } from 'styled-components';

import {
  breakpoints,
  colors,
  convertPxToRem,
  fonts,
  shadows
} from '@proprioo/salatim';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;

  @media (min-width: ${breakpoints.xsmall}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  h3 {
    font-weight: bold;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  > button {
    margin-right: ${convertPxToRem(24)};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${convertPxToRem(24)};

  @media (min-width: ${breakpoints.xsmall}px) {
    margin: 0;
    flex-direction: row;
  }
`;

export const Subtitle = styled.p`
  color: ${colors.dark.base80};
  font: ${fonts.smallest};
  font-weight: bold;
  padding: 0;
  margin: 0 0 ${convertPxToRem(12)};

  @media (min-width: ${breakpoints.xsmall}px) {
    margin: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 0;
  height: 100%;
  margin: ${convertPxToRem(24)} 0;

  @media (min-width: ${breakpoints.xsmall}px) {
    margin: ${convertPxToRem(40)} 0 0;
  }
`;

export const WrapperLoader = styled.div`
  position: absolute;
  top: 35vh;
  left: 50%;
`;

export const NoResult = styled.div`
  margin: ${convertPxToRem(100)} auto;
  text-align: center;
`;

export const TableContainer = styled.div`
  position: relative;
  z-index: 0;
  height: 100vh;
`;

export const PreviewContainer = styled.aside<{
  isOpen: boolean;
  top: number;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 15;
  overflow-y: auto;
  padding: ${convertPxToRem(16)};
  transform: translateX(${convertPxToRem(405)});
  transition: all 0.2s cubic-bezier(0.175, 0.75, 0.4, 1);
  background-color: ${colors.green.base5};
  box-shadow:
    inset 0 ${convertPxToRem(4)} ${convertPxToRem(8)} ${convertPxToRem(-4)}
      rgba(51, 51, 51, 0.08),
    ${shadows.level2};

  @media (min-width: ${breakpoints.xsmall}px) {
    left: unset;
    width: ${convertPxToRem(405)};
    padding: ${convertPxToRem(16)} ${convertPxToRem(24)};
  }

  ${({ top }) =>
    top &&
    css`
      top: ${convertPxToRem(top)};
    `};

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: translateX(0);
    `};
`;

export const PaginationWrapper = styled.div`
  margin: ${convertPxToRem(16)} 0;

  @media (min-width: ${breakpoints.small}px) {
    margin: ${convertPxToRem(32)} 0;
  }
`;
